import React, { Component, useState } from "react"
import { Channel, Connection, Port, RootState, RoutingResult } from ".."
import { SVGEditorGlobals, View } from "./SVGEditor"
import { useSelector } from "react-redux"
import { lighten, shades } from "../Utils/Color"

export { ChannelSVGViewer }

function ChannelSVGViewer(props: {
  connection: Connection
  routingResult: RoutingResult
  hover: boolean
  setHover: (hover: boolean) => void
  globals: SVGEditorGlobals
}) {

  const settings = useSelector((state: RootState) => state.settings)
  const colorScheme = shades(props.connection.color ?? settings.connectionDefaultColor)
  const selected = props.globals.selection.selected === props.connection.id
  const highlighted = selected || props.hover
  const showSpacing = highlighted

  return <g
      onClick={(e) => {
        selected ? props.globals.selection.setSelected(''): props.globals.selection.setSelected(props.connection.id)
        e.stopPropagation()
      }}
    >
      {props.routingResult.channel !== undefined && showSpacing &&
        <path
          d={props.routingResult.channel.path.pathString}
          strokeWidth={props.routingResult.channel.width + 2 * props.connection.spacing}
          stroke={colorScheme.shadow}
          fill='none'
          opacity={0.4}
          style={{
            transition: 'all 0.15s ease-in'
          }}
        ></path>
      }
      { props.routingResult.channel !== undefined &&
        <path
        d={props.routingResult.channel.path.pathString}
        className={props.connection.modifyLength && !props.routingResult.routingWithLengthFound ? 'routingFailure' : ''}
        style={{
          transition: 'all 0.15s ease-in',
          fill: 'none',
          stroke: props.connection.modifyLength && !props.routingResult.routingWithLengthFound ? undefined : (highlighted ? colorScheme.highlightColor : colorScheme.color),
          strokeWidth: props.routingResult.channel.width
        }}
      ></path>
      }
    </g>
}
